import {cast, getSnapshot, Instance, types} from "mobx-state-tree";
import {nanoid} from "nanoid";

import {getGqlModelBase} from "../gqlModel/GqlModelBase";
import {QuizQuestion} from "../../@types/Quiz";
import {QuizQuestionOptionModel, QuizQuestionOptionModelType} from "./QuizQuestionOptionModel";

export type QuizQuestionModelType = Instance<typeof QuizQuestionModel>;

/* A graphql query fragment builders for QuizModel */

/**
 * QuizModel
 */
export const QuizQuestionModel = getGqlModelBase<QuizQuestion>()
    .named("QuizQuestionModel")
    .props({
        id: types.optional(types.identifier, () => nanoid()),
        ownerIdAndWsId: types.string,
        quizId: types.string,
        text: types.optional(types.string, ''),
        options: types.array(QuizQuestionOptionModel),
    })
    .views(self => ({
        get correctOptions() {
            return self.options.filter(option => option.isCorrect);
        },
        get hasError() {
            if (!self.text) {
                return true;
            }
            let hasRightAnswer = false;
            for (const option of self.options) {
                if (!option.text) {
                    return true;
                } else if (option.isCorrect) {
                    hasRightAnswer = true;
                }
            }
            return !hasRightAnswer;
        },
    }))
    .actions(self => ({
        setText(text: string) {
            self.text = text;
            self.hasChanges = true;
        },
        addOption() {
            self.options = cast([...self.options, QuizQuestionOptionModel.create({})]);
            self.hasChanges = true;
        },
        removeOption(option: QuizQuestionOptionModelType) {
            self.options.remove(option);
            self.hasChanges = true;
        },
        reorder(startIndex: number, endIndex: number) {
            const [itemToMove] = self.options.splice(startIndex, 1);

            self.options.splice(endIndex, 0, getSnapshot(itemToMove));
            self.hasChanges = true;
        },
        setOptions(options: any) {
            self.options = options;
        }
    }));
